import * as React from 'react'
import styled from 'styled-components'
import { device } from '../../templates/displays/devices'
import left_align_logo from '@/public/assets/logo/left_align_logo.svg'

const LeftAlignedLogoWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* width: 100%; */
`

const Logo = styled.img`
    width: 200px;

    @media ${device.mobile} {
        width: 64%;
    }
`

type IProps = { dataAttId?: string }

const LeftAlignedLogo: React.FunctionComponent<IProps> = (props) => {
    return (
        <LeftAlignedLogoWrapper>
            <a
                href="https://app.custodian.club"
                target="_blank"
                rel="noreferrer"
                data-attr={props.dataAttId}
            >
                <Logo src={left_align_logo.src} />
            </a>
        </LeftAlignedLogoWrapper>
    )
}

export default LeftAlignedLogo
